var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.001,
    height: 73.132,
    viewBox: "0 0 78.001 73.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7c2d35;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.941 -30.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.6,73.132H7.4A7.381,7.381,0,0,1,.916,62.188L32.509,3.874a7.376,7.376,0,0,1,12.983,0L77.083,62.188h0a7.381,7.381,0,0,1-6.468,10.944Zm0-5.093a2.3,2.3,0,0,0,2-1.145h0a2.293,2.293,0,0,0,.076-2.309L41.055,6.238a2.341,2.341,0,0,0-4.11,0L5.326,64.586A2.341,2.341,0,0,0,7.4,68.039ZM36.474,56.75V53.383a2.526,2.526,0,0,1,5.052,0V56.75a2.526,2.526,0,0,1-5.052,0Zm0-11.786V24.76a2.526,2.526,0,1,1,5.052,0v20.2a2.526,2.526,0,0,1-5.052,0Z",
    transform: "translate(12.941 30.211)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureicon);
export default __webpack_public_path__ + "static/media/failure.icon.7426e3ca4995035160fe51b1fe339499.svg";
export { ForwardRef as ReactComponent };